export const maskActivities = (activities: string): string => {
  if (!activities) {
    console.log('maskActivities', { activities });
  }
  const output = activities
    .split(/<br\s*\/?>/i)
    .map((line) => {
      if (!line || !line.trim()) return line;
      const lineUpperCase = line.toUpperCase();
      if (line === lineUpperCase) {
        return line.toLowerCase().replace(/^\w|\.\s+|!\s+|\?\s+\w/g, (char) => char.toUpperCase());
      }
      return line;
    })
    .join('<br/>');
  return output;
};
